import { Box, Title } from '@mantine/core';
import type { FC, ReactNode } from 'react';
import { Element } from 'react-scroll';

export const FormPanel: FC<{
  children: ReactNode;
  title: string;
  name: string;
}> = ({ children, title, name }) => (
  <Element name={name}>
    <Box bg="white" p="lg" style={{ borderRadius: 'var(--mantine-radius-sm)' }}>
      <Title mb="md" order={3} py="xxxs" style={{ borderBottom: '1px solid #191919' }}>
        {title}
      </Title>
      {children}
    </Box>
  </Element>
);
